var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MenuButton',{attrs:{"links":_vm.links,"tooltip":_vm.tooltip}},[_c('v-avatar',{attrs:{"color":"secondary lighten-5","size":"36"}},[_c('span',{staticClass:"black--text font-weight-bold"},[_vm._v(_vm._s(_vm.initials(_vm.username)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }